export class CustomerCard {
    name: string;
    creditCard: string;
    expirationDate: string;
    // cvc: number;
}